import { BaseModelKeys } from '@ag-common-lib/lib/models/base.model';
import { AgencyKeys, Agent, AgentKeys, LookupKeys, TRUE_FALSE_LOOKUP } from '@ag-common-lib/public-api';
import { Component, effect, HostBinding, Input, output } from '@angular/core';
import { AgencyService } from 'ag-common-svc/public-api';
import { RowDraggingAddEvent, RowPreparedEvent } from 'devextreme/ui/tree_list';
import { AgencyHierarchyManagementService } from './agency-hierarchy-management.service';
import { AgencyHierarchyManagerMode, MgaHierarchy } from './agency-hierarchy-management.model';

@Component({
  selector: 'ag-crm-agency-hierarchy-management',
  templateUrl: './agency-hierarchy-management.component.html',
  styleUrls: ['./agency-hierarchy-management.component.scss'],
})
export class AgencyHierarchyManagementComponent {
  @HostBinding('class') className = 'agency-hierarchy-management';

  @Input() unassignedGridTitle = 'Unassigned Agents';
  @Input() mgaHierarchyGridTitle = 'MGA Hierarchy';
  @Input() targetMgaHierarchyGridTitle = '';

  @Input() set mode(data: AgencyHierarchyManagerMode) {
    this.agencyHierarchyManagementService.setMode(data);
  }
  @Input() set mga(data) {
    this.agencyHierarchyManagementService.setMga(data);
  }

  public onHierarchyChanged = output<Record<string, Agent>>();
  public onOriginMgaHierarchyChanged = output<MgaHierarchy>();
  public hierarchyChangesMapSig = this.agencyHierarchyManagementService.hierarchyChangesMapSig;
  public hasHierarchyChangesSig = this.agencyHierarchyManagementService.hasHierarchyChangesSig;

  protected BaseModelKeys = BaseModelKeys;
  protected AgentKeys = AgentKeys;
  protected AgencyKeys = AgencyKeys;
  protected LookupKeys = LookupKeys;
  protected trueFalseLookup = TRUE_FALSE_LOOKUP;
  protected agencyNamesDataSourceConfiguration = this.agencyService.agencyNamesDataSourceConfiguration;
  protected freeAgentsDataSourceSig = this.agencyHierarchyManagementService.freeAgentsDataSourceSig;
  protected targetMgaHierarchyDataSourceSig = this.agencyHierarchyManagementService.targetMgaHierarchyDataSourceSig;
  protected originMgaHierarchyDataSourceSig = this.agencyHierarchyManagementService.originMgaHierarchyDataSourceSig;

  protected hasOriginMgaSig = this.agencyHierarchyManagementService.hasOriginMgaSig;
  protected hasTargetMgaSig = this.agencyHierarchyManagementService.hasTargetMgaSig;
  protected originMgaGridTitleSig = this.agencyHierarchyManagementService.originMgaGridTitleSig;
  protected originMgaNoDataTextSig = this.agencyHierarchyManagementService.originMgaNoDataTextSig;
  protected targetMgaGridTitleSig = this.agencyHierarchyManagementService.targetMgaGridTitleSig;
  protected targetMgaNoDataTextSig = this.agencyHierarchyManagementService.targetMgaNoDataTextSig;

  constructor(
    private agencyService: AgencyService,
    public agencyHierarchyManagementService: AgencyHierarchyManagementService,
  ) {
    effect(() => {
      const hierarchyChangesMap = this.agencyHierarchyManagementService.hierarchyChangesMapSig();

      this.onHierarchyChanged.emit(hierarchyChangesMap);
    });
  }

  revertChange = this.agencyHierarchyManagementService.revertChange;

  clearChanges = this.agencyHierarchyManagementService.clearChanges;

  protected handleReorderMgaHierarchy = this.agencyHierarchyManagementService.handleReorderMgaHierarchy;

  protected handleDragChange = this.agencyHierarchyManagementService.handleDragChange;

  protected onMgaHierarchyRowPrepared = (e: RowPreparedEvent) => {
    if (e.rowType !== 'data') {
      return;
    }

    this.agencyHierarchyManagementService.onMgaHierarchyRowPrepared(e);
  };

  protected handleAddFreeAgents = (e: RowDraggingAddEvent) => {
    const mga = this.agencyHierarchyManagementService.originMgaSig();
    const preparedChanges = this.agencyHierarchyManagementService.prepareAddAgents(mga, e);

    this.agencyHierarchyManagementService.applyPreparedChanges(preparedChanges);
  };

  protected handleAddAgentToTarget = (e: RowDraggingAddEvent) => {
    const mga = this.agencyHierarchyManagementService.targetMgaSig();
    const preparedChanges = this.agencyHierarchyManagementService.prepareAddAgents(mga, e);

    if (!preparedChanges) {
      return;
    }

    this.agencyHierarchyManagementService.applyPreparedChanges(preparedChanges);
  };
}
